<!--  -->
<template>
  <div>

    <!-- title -->
    <div class="title">
      <div style="margin: 0.8em 0 0.8em  0;">
        <h3>Send Money to This Bank</h3>
      </div>
    </div>

    <!-- orderID -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- time left -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!-- copy -->
    <div class="pannel" v-if="orderInfo.orderId">
      <div class="infoContainer">
        <div class="items1">Bank:</div>
        <div class="items2">
          <span v-if="copyBankIf" style="color: green;"><b>{{orderInfo.recBank}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recBank}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyBank" class="btn copy">Copy</button>
        </div>
      </div>
      <div class="infoContainer">
        <div class="items1">Receiver's:</div>
        <div class="items2">
          <span v-if="copyOwnerIf" style="color: green;"><b>{{orderInfo.recOwner}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recOwner}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyOwner" class="btn copy">Copy</button>
        </div>
      </div>
      <!-- <div class="infoContainer">
        <div class="items1">Mobile:</div>
        <div class="items2">
          <span v-if="copyAccountIf" style="color: green;"><b>{{orderInfo.recAccount}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recAccount}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyAccount" class="btn copy">Copy</button>
        </div>
      </div> -->
      <div class="infoContainer">
        <div class="items1">CardNo:</div>
        <div class="items2">
          <span v-if="copyCardNoIf" style="color: green;"><b>{{orderInfo.recCardNo}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recCardNo}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyCardNo" class="btn copy">Copy</button>
        </div>
      </div>
      <div class="infoContainer">
        <div class="items1">Amount:</div>
        <div class="items2">
          <span v-if="copyAmountIf" style="color: green;"><b>{{orderInfo.amount}}</b></span>
          <span v-else style="color: red;"><b>{{orderInfo.amount}}</b></span>
        </div>
        <div class="items3">
          <button @click="copyAmount" class="btn copy">Copy</button>
        </div>
      </div>
    </div>

    <!-- 操作 -->
    <div class="pannel" v-if="orderInfo.orderId">
      <div class="pay-flow" style="font-size: 0.8em;">
        <p class="no">1. Enter Reference Code.</p>
        <p class="no">2. Upload a picture of your payment receipt image.</p>
      </div>
      <!--提交参考吗-->
      <div class="submit-container">
        <input type="text" v-model="rcode" placeholder="Enter Reference Code." style="width: 50%; font-size: 1em; height: 1.5em; padding: 0 10px; border: 1px solid #ccc;" />
        <button type="button" @click="rcodeSubmit()" style="height: 1.5em; padding: 0 1.5em; font-size: 1em;">submit</button>
      </div>
      <!--上传凭证-->
      <div class="pannel-btn" style="margin-top: 1em;">
        <input ref="file1" type="file" name="file1" style="visibility: hidden;width: 0; height: 0;" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="fileSelected">
        <button class="btn btn-alip" style="width: 80%;" @click="fileOpen">
          Upload the payment receipt image
        </button>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- other pay -->
    <div class="pannel" v-if="recQrUrlImg">
      <div class="pay-flow">
        <p style="color: #4CAF50;"><b>You can also try scan QrCode:</b></p>
        <table>
          <tr>
            <td style="width: 50%;">
              <div>
                <img :src="recQrUrlImg" style="margin: 0 auto;width: 80%;" />
              </div>
            </td>
            <td style="width: 50%;">
              <div class="pay-flow" style="font-size: 0.8em;">
                <p class="no">1. Download and save the QR code image</p>
                <p class="no">2. Use APP to scan QR code and pay</p>
              </div>
              <div class="pannel-btn">
                <a class="btn down" :href="recQrUrlImg" :download="`${orderInfo.orderId}-${orderInfo.amount}.png`" style="padding:0.4em;">Download</a>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Notice -->
    <div class="pannel-simp attention">
      <p class=""><b>Notice:&nbsp;</b><span style="color: red;">Please do not pay beyond the time limit, </span>otherwise it cannot be recovered!!!</p>
      <p class=""><b>Notice:&nbsp;</b><span style="color: red;">Please do not modify the amount, </span>otherwise it cannot be recovered!!!</p>
      <p class=""><b>Notice:&nbsp;</b><span style="color: red;">Not checked before the next day, </span>cannot be recovered!!!</p>
      <p class=""><b>Notice:&nbsp;</b>Payment successful confirmation time: <span style="color: red;">5 to 10 minutes</span>, After payment, The account has not been received for more than <span style="color: red;">10 minutes,</span> Please contact customer service to check the order!</p>
    </div>

    <!-- 弹出确认框 -->
    <div class="vdf-modal" v-if="showMsg1">
      <div class="vdf-modal-content">
        <div style="font-size: 0.95em;" v-if="showMsg1Over">{{showMsg1Txt}}</div>
        <div style="font-size: 0.95em;" v-else>Please Wait ...</div>
        <button class="btn bankcard-copy" @click="rcodeClose" v-if="showMsg1Over">Close</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as apis from "@/apis/apis";
//
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
//
import QRCode from "qrcode";
//
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关
      copyBankIf: false,
      copyOwnerIf: false,
      copyAccountIf: false,
      copyCardNoIf: false,
      copyAmountIf: false,
      copyTranMarkIf: false,
      //
      recQrUrlImg: "",
      //
      rcode: "",
      //
      showMsg1: false,
      showMsg1Txt: "Operation successful",
      showMsg1Over: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    //
    init() {
      this.rcode = this.orderInfo.tranMark;
      // 生成二维码;
      if (this.orderInfo.recQrUrl) {
        QRCode.toDataURL(
          this.orderInfo.recQrUrl,
          { errorCorrectionLevel: "L", margin: 1, width: 500 },
          (err, url) => {
            if (err) {
              return;
            }
            this.recQrUrlImg = url;
          }
        );
      }
    },
    // 复制银行
    copyBank: function () {
      this.$parent.copySome(
        this.orderInfo.recBank,
        1,
        () => {
          this.copyBankIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyOwner: function () {
      this.$parent.copySome(
        this.orderInfo.recOwner,
        1,
        () => {
          this.copyOwnerIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyAccount: function () {
      this.$parent.copySome(
        this.orderInfo.recAccount,
        1,
        () => {
          this.copyAccountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyCardNo: function () {
      this.$parent.copySome(
        this.orderInfo.recCardNo,
        1,
        () => {
          this.copyCardNoIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制金额
    copyAmount: function () {
      this.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.copyAmountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyTranMark: function () {
      this.$parent.copySome(
        this.orderInfo.tranMark,
        2,
        () => {
          this.copyTranMarkIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 提交code
    rcodeSubmit() {
      this.showMsg1 = true;
      this.showMsg1Over = false;
      apis
        .bkcd_np_rcode({
          id: this.orderInfo.orderId,
          rcode: this.rcode,
        })
        // eslint-disable-next-line
        .then((res) => {
          this.showMsg1Txt = "Reference Code submitted successfully！";
          this.showMsg1Over = true;
        });
    },
    rcodeClose() {
      this.showMsg1 = false;
      this.showMsg1Over = false;
    },
    // 上传文件
    fileOpen() {
      this.$refs.file1.click();
    },
    // 已选择文件
    fileSelected(event) {
      let that = this;
      // 获取文件
      const files = event.target.files;
      // 读取
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (event) => {
        //console.log(reader.result);
        // console.log(event.target.result);
        // 创建 Image 对象
        var img = new Image();
        img.src = event.target.result;
        img.onload = function () {
          var _this = this;
          // 大小处理
          let maxSize = 800;
          let width = img.width;
          let height = img.height;
          if (width > height) {
            height = maxSize * (height / width);
            width = maxSize;
          } else {
            width = maxSize * (width / height);
            height = maxSize;
          }
          // 获取 canvas 元素
          var canvas = document.createElement("canvas");
          // 绘制图像到 canvas
          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(_this, 0, 0, width, height);
          // 使用 toDataURL 方法压缩图像
          var dataUrl = canvas.toDataURL("image/jpeg", 0.3);
          // 上传
          that.showMsg1 = true;
          that.showMsg1Over = false;
          apis
            .bkcd_np_cimg({
              id: that.orderInfo.orderId,
              cimg: dataUrl,
            })
            // eslint-disable-next-line
            .then((res) => {
              that.showMsg1Txt = "Image uploaded successfully!";
              that.showMsg1Over = true;
            });
        };
      };
    },
  },
};
</script>

<style>
.submit-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>

<style lang="scss" scoped>
</style>
